// Shared between AcceptInvite.jsx (which parks a code when the visitor isn't
// logged in yet) and Login.js/Registration.jsx (which consume it right after
// a successful sign-in/sign-up).
export const PENDING_INVITE_KEY = "sety_pending_invite_code";

export function consumePendingInvite(axios, URL) {
  const code = localStorage.getItem(PENDING_INVITE_KEY);
  if (!code) return Promise.resolve(null);
  localStorage.removeItem(PENDING_INVITE_KEY);
  return axios.post(`${URL}onboarding/accept-invite/${code}`).catch(() => null);
}
